import {createReducer, on} from "@ngrx/store";
import {HomeState} from "../app.state";
import {
  deliveryProofSuccess,
  isWarehosueOrderId,
  getOrderDetailsDataSucess,
  getOrderTrackInfoConfigSucess,
  isOrderInParamsAction,
  loadCarrierDataSuccess,
  loadDeliveryDataFailure,
  loadDeliveryDetails,
  loadDeliveryDetailsAndFeatureVisibilitySuccess,
  loadEtaSuccess,
  loadOrderStatus,
  loadOrderStatusSuccess,
  loadOrderTrackByIdSuccess,
  loadRatingsSuccess,
  loadTrackDetailsSuccess,
  postRatingSuccess,
  setAgentLatLng,
  setDeliverTokenId,
  setDeliveryAcknowledgeViewStatus,
  setOrderIdForTimeline,
  setDocketId,
  setOrderStatusForTimeline,
  setStatusData,
  setTrackData,
  setAccountLogoForOrderIdSuccess,
} from "./home.action";
import {LatLng} from "leaflet";
import {ACC_IMAGE, GET_AGENT_IMAGE} from "../../service/constants";
import {getApiBaseUrl} from "../../config/api";
import {
  DeliveryAgent,
  IOrderStatus,
  IOrderTrackByIdResponse,
  IOrderTrackTimelineItem,
  IRatingDetails,
  Location,
  OrderDeliveryDetails,
  OrderInfoDetails,
  TimeLine,
  TimelineEvent
} from "../../models/DeliveryDetails";
import {UtilityService} from "src/app/service/utility.service";
import {TrackData} from "src/app/models/custom.types";

const utilityService = new UtilityService()
const initialState: HomeState = {
  deliveryTokenId: '',
  status: '',
  loading: false,
  apiError: false,
  deliveryDetails: undefined,
  agentLatLng: undefined,
  deliveryLatLng: undefined,
  pickUpLatLng: undefined,
  agentImage: undefined,
  accountImage: undefined,
  orderTimeLineDetails: [],
  orderDetails: undefined,
  deliveryAgentDetails: undefined,
  polyline: [],
  deliveryDateTimeDetails: undefined,
  deliveryLocationDetails: undefined,
  ratingDetails: undefined,
  trackData: undefined,
  statusData: undefined,
  successAnimationMsg: undefined,
  etaDetails: undefined,
  orderStatus: undefined,
  deliveryAcknowledgeViewStatus: false,
  featureVisbilityProperties:undefined,
  warehouseOrderId:'',
  isParamOrderId:'',
  orderIdForTimeline:'',
  docketId:'',
  orderStatusForTimeline:'',
  orderDataInfoConfig:{
    canUpdateContactInfo:false,
    canUpdateLocation:false,
    canUpdateNotes:false,
    isActive:false
  },
  orderDocuments:[]
}

export const HomeReducer = createReducer(
  initialState,
  on(setAgentLatLng, (state, {data}) => {
    return {
      ...state,
      agentLatLng: data
    }
  }),
  on(setTrackData, (state, {data}) => {
    const latlng = new LatLng(parseFloat(data.latitude ?? ""), parseFloat(data.longitude ?? ""))
    return {
      ...state,
      agentLatLng: latlng,
      trackData: data,
      // polyline: [...state.polyline ?? [], latlng]
    }
  }),
  on(setStatusData, (state, {data}) => {
    return {
      ...state,
      statusData: data
    }
  }),
  on(setDeliverTokenId, (state, {data}) => {
    return {
      ...state,
      deliveryTokenId: data,
      agentImage: `${getApiBaseUrl()}${GET_AGENT_IMAGE}?deliveryTokenId=${data}`,
      accountImage: `${getApiBaseUrl()}${ACC_IMAGE}${data}?deliveryTokenId=${data}&type=customerTrack`,
      status: 'success'
    }
  }),
  on(loadDeliveryDetailsAndFeatureVisibilitySuccess, (state, {deliveryDetails:data,featureVisibility}) => {
    let pll, dll, otl = new Array<TimelineEvent>(), all,
      orderInfo: OrderInfoDetails = {
        name: '',
        orderId: '',
        orderList: [],
        moduleType: ''
      };
    let deliveryAgentDetails: DeliveryAgent = {name: '', mobileNo: ''}

    let orderDateTimeDetails: OrderDeliveryDetails = {expectedDeliveryDetails: '', actualDeliveryDetails: ''};
    let deliveryLocationDetails: Location = {
      lng: '',
      lat: '',
      address: '',
      pincode: 0,
      city: '',
      state: '',
      country: '',
    }
    const pu = data?.assetObj?.order.pickUpLocation;
    const dp = data?.assetObj?.deliveryPerson;
    const cd = data?.assetObj?.order.customerDetails.location;
    const tl = data?.timeLine
    const od = data?.assetObj?.order


    if (pu && parseFloat(`${pu.lat}`) && parseFloat(`${pu.lng}`)) {
      pll = new LatLng(parseFloat(`${pu.lat}`), parseFloat(`${pu.lng}`));
    }

    if (dp && parseFloat(`${dp.lastLat}`) && parseFloat(`${dp.lastLng}`)) {
      all = new LatLng(parseFloat(`${dp.lastLat}`), parseFloat(`${dp.lastLng}`));
    }

    if (cd && parseFloat(`${cd.lat}`) && parseFloat(`${cd.lng}`)) {
      dll = new LatLng(parseFloat(`${cd.lat}`), parseFloat(`${cd.lng}`));
    }

    if (tl && tl.length !== 0) {
      otl = tl.map((e, i) => {
        let label = ''
        if (e?.deliveryStatus) {
          label = e?.['deliveryStatus']
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, (str: string) => str.toUpperCase().replace(/^\s+|\s+$/gm, ''));
        }

        let icon = 'pi '
        let status = '';

        if (checkForNegativeEventStatus(e)) {
          icon = `${icon}pi-times`
          status = 'failure'
        } else {
          icon = `${icon}pi-check`
          status = 'success'
        }

        if (i == (tl.length - 1) && e?.deliveryStatus == 'inProgress') {
          status = 'halted'
        }

        let details = utilityService.getStatusMsg(e, '');
        let imgIds: string[] = e?.imageId?.map((e) => {
          return utilityService.getCarouselImgUrl(e, state.deliveryTokenId)
        });

        const timelineDate = e?.['date']
        const parsedTimelineDate = timelineDate === 'NA' ? null : new Date(timelineDate)

        return {
          status: label,
          date: parsedTimelineDate ? utilityService.getFormattedDate(parsedTimelineDate) : 'NA',
          time: parsedTimelineDate ? utilityService.getTime(parsedTimelineDate) : '',
          displayDateTime: parsedTimelineDate ? utilityService.getFormattedDate(parsedTimelineDate, 'long') : '',
          details: details,
          icon: icon,
          currentStatus: status,
          carouselImgIds: imgIds,
          description: (e?.description ? e?.description : ''),
          boxTemp: e?.boxTemp,
        }
      });

      const alreadyAcknowledged =
        tl?.some(e => e?.deliveryStatus?.toLowerCase().includes('acknowledged')) ||
        state.deliveryAcknowledgeViewStatus;

      if (
        state.orderStatus?.isOrderCompleted &&
        !state.orderStatus?.isOrderCancelled &&
        !alreadyAcknowledged
      ) {
        otl.push({
          status: "Confirm Delivery",
          date: '-',
          time: '-',
          details: '',
          icon: ' pi pi-check-circle',
          currentStatus: 'halted',
          carouselImgIds: [],
          description: 'Click to confirm'
        })
      }
    }

    if (!otl.some(event => event.status === 'Order Created')) {
      const orderCreatedDate = new Date(od?.created ?? '')
      otl.unshift({
        status: "Order Created",
        date: utilityService.getFormattedDate(orderCreatedDate),
        time: utilityService.getTime(orderCreatedDate),
        displayDateTime: utilityService.getFormattedDate(orderCreatedDate, 'long'),
        details: "Order Created",
        icon: 'pi pi-check',
        currentStatus: 'success',
        carouselImgIds: [''],
        description: ''
      })
    }

    if (od?.customerDetails) {
      od?.customerDetails?.firstName ? orderInfo['name'] = od.customerDetails.firstName : '';
    }

    if (od) {
      const orderID = od?.orderDetails?.orderId || od?.orderId
      if(orderID){
        orderInfo['orderId'] = "#" + orderID
      }
      if (od.orderDetails?.items?.length > 0) {
        orderInfo['orderList'] = od.orderDetails?.items
      }

      if (od?.expectedDeliveryDateTime?.dateTime) {
        if (orderDateTimeDetails['expectedDeliveryDetails'] !== null) {
          orderDateTimeDetails['expectedDeliveryDetails'] = utilityService.getFormattedDate(new Date(od?.expectedDeliveryDateTime?.dateTime), 'long')
        }
      }
    }

    if (data?.delivered_dateTime) {
      if (orderDateTimeDetails.actualDeliveryDetails !== null) {
        orderDateTimeDetails.actualDeliveryDetails = utilityService.getFormattedDate(new Date(data?.delivered_dateTime), 'long')
      }

    }

    if (data?.assetObj?.deliveryPerson?.name && data?.assetObj?.deliveryPerson?.mobileNo) {
      deliveryAgentDetails['name'] = data?.assetObj?.deliveryPerson?.name
      deliveryAgentDetails['mobileNo'] = data?.assetObj.deliveryPerson?.mobileNo
    }

    if (data?.moduleType) {
      orderInfo['moduleType'] = data?.moduleType
    }

    if (data?.assetObj?.order?.customerDetails?.location) {
      deliveryLocationDetails = data?.assetObj?.order?.customerDetails?.location
    }

    const pu_loc = data?.assetObj?.order?.pickUpLocation;
    const pickUpLocationDetails = (pu_loc?.name || pu_loc?.address)
      ? { name: pu_loc.name ?? '', address: pu_loc.address ?? '' }
      : undefined;

    return {
      ...state,
      deliveryDetails: data,
      status: 'success',
      pickUpLatLng: pll,
      deliveryLatLng: dll,
      agentLatLng: all,
      orderTimeLineDetails: otl.reverse(),
      orderDetails: orderInfo,
      deliveryAgentDetails: deliveryAgentDetails,
      deliveryDateTimeDetails: orderDateTimeDetails,
      deliveryLocationDetails: deliveryLocationDetails,
      featureVisbilityProperties: featureVisibility,
      orderDocuments:data?.orderDocuments,
      pickUpLocationDetails,
    }
  }),

  on(loadTrackDetailsSuccess, (state, {data}) => {
    const m = data.map(e => new LatLng(e.coordinates[0], e.coordinates[1]));
    return {
      ...state,
      status: 'success',
      polyline: m,
      // agentLatLng: m.length ? m[0] : state.agentLatLng
    }
  }),
  on(loadCarrierDataSuccess, (state, {data}) => {
    const trackData: TrackData = {
      deviceId: "",
      generatedTimeStamp: data.timeStamp,
      sensorData: {
        temperature: Number.isNaN(Number(data.temperature)) ? '' :parseFloat(`${data.temperature}`).toFixed(3)
      }
    };
    if(Number.isNaN(Number(data?.lat)) || Number.isNaN(Number(data?.lng))){
      //Not Sending agentLatLng if LatLng values are not valid...
      return {
        ...state,
        status: 'success',
        trackData: trackData
      }
    }

    return {
      ...state,
      status: 'success',
      trackData: trackData,
      agentLatLng: new LatLng(parseFloat(data?.lat), parseFloat(data?.lng))
    }
  }),

  on(loadOrderStatusSuccess, (state, {data}) => {
    return {
      ...state,
      orderStatus: data
    }
  }),

  on(loadEtaSuccess, (state, {data}) => {
    return {
      ...state,
      etaDetails: data
    }
  }),

  on(loadRatingsSuccess, (state, {data}) => {
    return {
      ...state,
      ratingDetails: data
    }
  }),
  on(postRatingSuccess, (state, {data}) => {
    let ratingDetails: IRatingDetails[] = data?.map((rating) => {
      let ratingObj: IRatingDetails = {
        _id: '',
        type: rating.type,
        stars: rating.stars,
        comments: rating.comments
      }
      return ratingObj
    })
    return {
      ...state,
      ratingDetails: ratingDetails
    }
  }),
  on(deliveryProofSuccess, (state, {msg}) => {
    const now = new Date();
    const updatedTimeline = (state.orderTimeLineDetails ?? []).map(event =>
      event.status === 'Confirm Delivery'
        ? {
            ...event,
            status: 'Delivery Acknowledged',
            currentStatus: 'success' as const,
            date: utilityService.getFormattedDate(now),
            time: utilityService.getTime(now),
            displayDateTime: utilityService.getFormattedDate(now, 'long'),
            description: 'Delivery confirmed',
          }
        : event
    );
    return {
      ...state,
      successAnimationMsg: msg,
      orderTimeLineDetails: updatedTimeline,
    }
  })
  ,
  on(setDeliveryAcknowledgeViewStatus, (state, {status}) => {
    const deliveryAcknowledgeViewStatus = (typeof (JSON.parse(status))==='boolean') ? JSON.parse(status) : false
    return {
      ...state,
      deliveryAcknowledgeViewStatus
    }
  }),
  on(isWarehosueOrderId ,(state,{orderId})=>{
    return{
      ...state,
      warehouseOrderId:orderId
    }
  }),
  on(isOrderInParamsAction , (state ,{value})=>{
    return{
      ...state,
      isParamOrderId:value
    }
  }),
  on(setOrderIdForTimeline , (state ,{value})=>{
    return{
      ...state,
      orderIdForTimeline:value,
      loading: true,
      apiError: false,
    }
  }),
  on(setDocketId , (state ,{value})=>{
    return{
      ...state,
      docketId:value,
      loading: true,
      apiError: false,
    }
  }),
  on(setOrderStatusForTimeline, (state, {value}) => ({
    ...state,
    orderStatusForTimeline: value,
  })),
  on(loadOrderTrackByIdSuccess, (state, {data}) => mapOrderTrackByIdToState(state, data)),
  on(getOrderDetailsDataSucess , (state ,{res})=>{
    let dll = new LatLng(parseFloat(`${res?.data?.ordersById?.customerDetails?.location?.lat}`), parseFloat(`${res?.data?.ordersById?.customerDetails?.location?.lng}`));
    let result = res?.data?.ordersById;
    return{
      ...state,
      orderDetailsData:result,
      deliveryLatLng:dll
    }
  }),
  on(getOrderTrackInfoConfigSucess , (state ,{data})=>{
    console.log(data)
    return{
      ...state,
      orderDataInfoConfig:data,
    }
  }),
  on(setAccountLogoForOrderIdSuccess, (state, {logo:res}) => {
    const logo = res?.images?.logo ?? res?.data?.accountsById?.images?.logo;
    const accountImage = logo?.url || (logo?.data && logo?.contentType ? `data:${logo.contentType};base64,${logo.data}` : '');

    return {
      ...state,
      accountImage: accountImage || state.accountImage,
    }
  }),
  // loading: true only on initial status fetch; details refreshes are silent
  on(loadOrderStatus, (state) => ({
    ...state,
    loading: true,
    apiError: false,
  })),
  on(loadDeliveryDetails, (state) => ({
    ...state,
    apiError: false,
  })),
  on(loadOrderStatusSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(loadDeliveryDataFailure, (state) => ({
    ...state,
    loading: false,
    apiError: true,
  })),
)


/*
  Maps the orderId tracking payload (GET /api/track/order/trackOrder?orderId=)
  into the same view-model state fields the tracking components consume, so the
  existing UI renders unchanged. The map/live/sensor data is intentionally not
  produced — the orderId view is a static (non-live) tracking screen.
*/
function mapOrderTrackByIdToState(state: HomeState, data: IOrderTrackByIdResponse): HomeState {
  const od = data?.order;
  const NEGATIVE_STATUSES = ['cancelled', 'deliverypartnerrejectedorder', 'deliverypartnerreturnedorder', 'lpcancelled', 'returned'];

  const items = (data?.timeline ?? [])
    .slice()
    .sort((a, b) => new Date(a?.date ?? a?.event?.date ?? 0).getTime() - new Date(b?.date ?? b?.event?.date ?? 0).getTime());

  const orderTimeLineDetails: TimelineEvent[] = items.map((e: IOrderTrackTimelineItem) => {
    const rawStatus = e?.event?.status ?? e?.deliveryStatusObj?.deliveryStatus ?? '';
    const customerStatus = e?.customerStatus ?? '';
    const address = e?.address ?? '';
    const isNegative = NEGATIVE_STATUSES.includes(rawStatus.toLowerCase());
    const rawDate = e?.date ?? e?.event?.date;
    const parsedDate = rawDate && rawDate !== 'NA' ? new Date(rawDate) : null;

    return {
      status: customerStatus,
      date: parsedDate ? utilityService.getFormattedDate(parsedDate) : 'NA',
      time: parsedDate ? utilityService.getTime(parsedDate) : '',
      displayDateTime: parsedDate ? utilityService.getFormattedDate(parsedDate, 'long') : '',
      details: address,
      icon: isNegative ? 'pi pi-times' : 'pi pi-check',
      currentStatus: isNegative ? 'failure' : 'success',
      carouselImgIds: [],
      // Only `details` is populated; the timeline renders `description` and
      // `details` as separate lines, so duplicating both would show text twice.
      description: '',
      customerStatus: e?.customerStatus ?? '',
    };
  }).reverse();

  const orderInfo: OrderInfoDetails = { name: '', orderId: '', orderList: [], moduleType: '' };
  const buyer = od?.buyerDetails;
  const customerName = [buyer?.firstName ?? od?.customerDetails?.firstName, buyer?.lastName ?? od?.customerDetails?.lastName]
    .filter(Boolean).join(' ').trim();
  if (customerName) orderInfo.name = customerName;
  const orderId = od?.orderDetails?.orderId || data?.orderId;
  if (orderId) orderInfo.orderId = '#' + orderId;
  if (od?.orderDetails?.items?.length) orderInfo.orderList = od.orderDetails.items;
  if (od?.moduleType) orderInfo.moduleType = od.moduleType;

  const agent = od?.agentData ?? od?.sellerAgent;
  const deliveryAgentDetails: DeliveryAgent = {
    name: agent?.name ?? '',
    mobileNo: agent?.mobileNo ?? '',
  };

  const orderDateTimeDetails: OrderDeliveryDetails = { expectedDeliveryDetails: '', actualDeliveryDetails: '' };
  if (od?.expectedDeliveryDateTime?.dateTime) {
    orderDateTimeDetails.expectedDeliveryDetails = utilityService.getFormattedDate(new Date(od.expectedDeliveryDateTime.dateTime), 'long');
  }
  if (od?.delivery?.delivered_dateTime) {
    orderDateTimeDetails.actualDeliveryDetails = utilityService.getFormattedDate(new Date(od.delivery.delivered_dateTime), 'long');
  }

  const emptyLocation: Location = { lng: '', lat: '', address: '', pincode: 0, city: '', state: '', country: '' };
  const deliveryLocationDetails: Location = (buyer?.location ?? od?.customerDetails?.location) ?? emptyLocation;

  const seller = od?.sellerDetails;
  const pickUpLocationDetails = (seller?.name || seller?.location?.address)
    ? { name: seller?.name ?? '', address: seller?.location?.address ?? '' }
    : undefined;

  const orderStatus: IOrderStatus = {
    isActive: false,
    isOrderCompleted: !!od?.delivery?.isOrderCompleted,
    isOrderCancelled: !!od?.delivery?.isOrderCancelled,
  };

  return {
    ...state,
    status: 'success',
    loading: false,
    apiError: false,
    orderTimeLineDetails,
    orderDetails: orderInfo,
    deliveryAgentDetails,
    deliveryDateTimeDetails: orderDateTimeDetails,
    deliveryLocationDetails,
    pickUpLocationDetails,
    orderStatus,
  };
}

function checkForNegativeEventStatus(e: TimeLine, additional = '') {
  if (additional !== '') {
    return e?.['deliveryStatus'] === additional
      || e?.['deliveryStatus'] === 'cancelled'
      || e?.['deliveryStatus'] === 'deliveryPartnerRejectedOrder'
      || e?.['deliveryStatus'] === 'deliveryPartnerReturnedOrder'
      || e?.['deliveryStatus'] === 'lpCancelled';
  } else {
    return e?.['deliveryStatus'] === 'cancelled'
      || e?.['deliveryStatus'] === 'deliveryPartnerRejectedOrder'
      || e?.['deliveryStatus'] === 'deliveryPartnerReturnedOrder'
      || e?.['deliveryStatus'] === 'lpCancelled';
  }
}

